var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVault = function SvgIconVault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 5.25V18a1.75 1.75 0 0 1-1.75 1.75H19V21a1 1 0 1 1-2 0v-1.25H7V21a1 1 0 1 1-2 0v-1.25H3.75A1.75 1.75 0 0 1 2 18V5.25c0-.966.784-1.75 1.75-1.75h16.5c.966 0 1.75.784 1.75 1.75M4 17.75V5.5h16V11h-2.251a4.002 4.002 0 0 0-7.874 1 4 4 0 0 0 7.874 1H20v4.75zM15.875 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconVault;